<template>
  <div class="">
    <div class="item">
      <div class="row">
        <vue-element-loading
          :active="isLoading"
          spinner="spinner"
          color="#28a745"
        />
        <div
          class="col-md-3 mb-4"
          v-for="(item, index) in best_seller"
          :key="`best_seller_${index}`"
        >
          <router-link
            :to="`/kewirausahaan/detail-barang/${item.id}`"
            class="card"
          >
            <div
              class="image"
              :style="{
                background: 'url(' + item.image + ')',
              }"
            ></div>

            <div class="content">
              <!-- name brand -->
              <div>
                <div class="brand">
                  <div class="name">
                    {{
                      item.title.length > 50
                        ? item.title.slice(0, 50) + `...`
                        : item.title
                    }}
                  </div>
                </div>

                <div class="title">{{ item.description }}</div>
              </div>
              <!-- rating and count sold -->
              <div class="row">
                <div class="col-6 border-right">
                  <div class="rating d-flex aling-items-center">
                    <img
                      :src="require('@/assets/images/kewirausahaan/rate.png')"
                      alt=""
                    />
                    <p class="ml-2 rating-number">{{ item.rating }}</p>
                  </div>
                </div>
                <div class="col-6">
                  <div class="sold">Terjual {{ item.sold }}</div>
                </div>
              </div>
              <div class="row mt-2 mb-2">
                <div class="col-12">
                  <div class=" border-bottom"></div>
                </div>
              </div>

              <!-- price -->
              <div class="row">
                <div class="col-12">
                  <div class="price">Rp{{ formatNumber(item.price) }}</div>
                </div>
              </div>
              <!-- location -->
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from "numeral";
import broker from "../../../../../utils/broker";
import VueElementLoading from "vue-element-loading";

export default {
  name: "PenjualanTerlaris",
  props: {
    detail_toko: {
      type: Object,
    },
  },
  components: {
    VueElementLoading,
  },
  data() {
    return {
      items: [1, 2, 3, 4],
      best_seller: [],
      isLoading: false,
      title:
        "TOPI Capten GAMING motif Minecraft warna hijau tosca dan abu abu biru muda",
    };
  },
  mounted() {
    this.getDataBestSeller();
  },
  methods: {
    getDataBestSeller() {
      let self = this;
      this.isLoading = true;

      broker.fetch
        .get(
          `/webschool/enterpreneur/merchant/${self.detail_toko.id}/goodies/best-seller`
        )
        .then((res) => {
          res.data.data.forEach((item) => {
            self.best_seller.push(item);
          });
          this.isLoading = false;
        });
    },
    formatNumber(value) {
      let formatted = numeral(value).format("0,0");
      return formatted;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_template_2.scss";
.store-icon {
  width: 16px;
}
</style>
